/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_PasswordInputs */

const cs_sreality_password = /** @type {(inputs: Sreality_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importní heslo`)
};

const en_sreality_password = /** @type {(inputs: Sreality_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import password`)
};

/**
* | output |
* | --- |
* | "Import password" |
*
* @param {Sreality_PasswordInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_password = /** @type {((inputs?: Sreality_PasswordInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_PasswordInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_password(inputs)
	return cs_sreality_password(inputs)
});